import { Service } from 'typedi';
import { computed, makeObservable, observable } from 'mobx';

@Service()
export default class UIStore {
    @observable title: string = `IDEXX Enterprise Admin`;

    constructor() {
        makeObservable(this);
    }

    @computed
    get name(): string {
        return this.title;
    }
}
